import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { TextField, Button, Select } from '@doxyme/ui';
import './AdminSsoForm.scss';
export const AdminSsoForm = ({ ssoService = {}, onSubmit, errors = {}, btnMessage, isDisabled, }) => {
    const errorText = (field) => errors[field]?.join('/n/t');
    const form = useForm({
        mode: 'onSubmit',
        defaultValues: {
            ...ssoService,
            identityAttrsArray: ssoService.identityAttrs?.split(',').map((v) => v.trim()) ?? [],
        },
    });
    const identityAttrs = [
        'id',
        'email',
        'name',
        'firstName',
        'lastName',
        'clinicName',
    ];
    const formOptions = identityAttrs.map((v) => {
        return {
            label: v,
            value: v,
        };
    });
    const handleSubmit = ({ identityAttrsArray, ...data }) => {
        onSubmit({
            ...data,
            identityAttrs: identityAttrsArray.join(','),
        });
    };
    return (<form className="form-wrapper" onSubmit={(...args) => void form.handleSubmit(handleSubmit)(...args)}>
      <TextField label="Name" name="name" placeholderText="Sso provider name" formGroupClassName="sso-service__form-group" hasError={Boolean(errors.name)} errorText={errorText('name')} type="text" ref={form.register({})}/>

      <TextField label="Redirect URL" name="redirectUrl" placeholderText="Url provided by SSO Service to send identity token to" formGroupClassName="sso-service__form-group" hasError={Boolean(errors.redirectUrl)} errorText={errorText('redirectUrl')} type="text" ref={form.register({})}/>

      <TextField label="Token Attribute name for example: ssoToken" name="tokenAttrName" placeholderText="Attribute with identity information to be added to redirectUrl" formGroupClassName="sso-service__form-group" hasError={Boolean(errors.tokenAttrName)} errorText={errorText('tokenAttrName')} type="text" ref={form.register({})}/>

      <Controller control={form.control} name="jwtPrivateKey" render={({ name, value, onChange, onBlur, ref }) => (<TextField placeholderText="Provided by SSO service" label="JWT private key" type="textarea" formGroupClassName="sso-service__form-group" wrapperClassName="from-wrapper__wider" hasError={Boolean(errors.jwtPrivateKey)} errorText={errorText('jwtPrivateKey')} name={name} value={value} onChange={onChange} onBlur={onBlur} ref={ref}/>)}/>

      <Select name="identityAttrsArray" formGroupClassName="sso-service__form-group" label="Identity attributes" control={form.control} multiple={true} options={formOptions} errors={form.errors}/>
      {errors.identityAttrs && (<p className="ui-form-helper-text ui-form-helper-text--error">
          {errorText('identityAttrs')}
        </p>)}

      <hr />
      <Button type="submit" btnStyle="solid" size="medium" disabled={isDisabled}>
        {btnMessage}
      </Button>
    </form>);
};
